import styled from 'styled-components';
import { colors, cssprops, pxToRem } from '@vfit/shared/themes';
import { IVfSwiperForStyled } from './vfSwiper.models';

export const SwiperWrapper = styled.div<IVfSwiperForStyled>`
  display: flex;

  .swiper {
    height: 100%;
    width: 100%;
  }

  .swiper-slide {
    border-radius: 0;
    height: auto;
    width: ${({ slideWidth }) => pxToRem(slideWidth)};
  }

  .swiper-pagination.swiper-pagination {
    ${({ pagination }) => (!pagination ? 'display: none;' : '')}
    margin-top: ${pxToRem(28)};
  }

  .swiper-horizontal > .swiper-pagination-bullets,
  .swiper-pagination-bullets.swiper-pagination-horizontal,
  .swiper-pagination-custom,
  .swiper-pagination-fraction {
    bottom: 0;
    margin-bottom: ${pxToRem(-4)};
  }

  ${cssprops.styled}
`;

export const Navigation = styled.div<Pick<IVfSwiperForStyled, 'navigationAlign'>>`
  align-items: ${({ navigationAlign }) => navigationAlign};
  display: flex;
  flex-shrink: 0;
`;

export const IconButton = styled.button`
  background: none;
  border: none;
  cursor: pointer;
  flex-shrink: 0;
  height: ${pxToRem(56)};
  padding: 0;
  width: ${pxToRem(40)};

  &:disabled {
    cursor: not-allowed;

    path {
      stroke: ${colors.$bebebe};
    }
  }
`;

